<div #refElement class="mat-elevation-z8 container-fluid stdTheme" style="overflow-y: hidden;overflow-x: hidden;"
        [ngStyle]="{'margin-top': '10px', width: ((!isSearch && !isAddOne) ? '100%' : '50%'),padding: '10px'}" >
       
    <div class="flex-row row wkscard" *ngIf="isFinishLoading">
        <div class="col-2  d-flex justify-content-start">
            <button mat-raised-button  #buttonSubmit type="reset" (click)="doCancel()">
                <mat-icon>arrow_back</mat-icon>
                {{ 'goback' | translate }}
            </button>
        </div>
        <div class="col-5 d-flex justify-content-center">
            <h5 class="titleTheme" >{{ titleCard | translate }}</h5>
        </div>
    </div>
        <div  class="flex-row row" >
        <div *ngIf="isFinishLoading " 
                class="w-100 col-12 dropzone"  draggable="true" #dropArea>
            <ng-container *ngTemplateOutlet="uploadTemplate"></ng-container>
        </div>
    </div>
</div>
<ng-template #uploadTemplate >
    <div  class="flex-row row dropzone" style="margin: 0px"  draggable="true" #dropArea >
        <div class="col-12"  style="padding-right: 5px; padding-left: 5px;">
            <form [formGroup]="uploadForm"  >
                <!-- https://stackblitz.com/edit/angular-material-elevation-hover?file=src%2Fapp%2Fapp.component.html -->
                <mat-card appMaterialElevation class="register-card stdTheme" layout="column" flex style="padding: 0px; padding-right: 5px; padding-left: 5px;">

                    <mat-card-content class="stdTheme" style="padding-bottom: 20px;overflow-y: auto;overflow-x: hidden; height: 500px; max-height: 500px">
                        <div class="flex-row row"  style="margin-bottom: 10px;">
                            <div class="col-2"></div>
                            <div class="col-3" >
                               <!--https://getbootstrap.com/docs/4.4/utilities/spacing/-->
                                <div class="pt-4 mt-2">
                                    <!--
                                    <button (click)="fileInput.click()" mat-raised-button class="buttonTheme" >
                                                <mat-icon>library_add</mat-icon>
                                        <span>{{'SelectFiles' | translate}}</span>
                                        <input #fileInput type="file" (change)="onFileChange($event)" [accept]="fileExt" style="display:none;" />
                                    </button>
                                    -->
                                    <button
                                        mat-raised-button
                                        class="buttonTheme"
                                        type="button"
                                        (click)="fileInput.click()"
                                        >
                                        <mat-icon>library_add</mat-icon>
                                        <span>{{ 'SelectFiles' | translate }}</span>
                                    </button>
                                    <input
                                        #fileInput
                                        type="file"
                                        [accept]="fileExt"
                                        (change)="onFileChange($event)"
                                        style="display: none"
                                        />

                                </div>
                            </div>
                            <div class="col-4">
                                <mat-form-field class="mdiinput form-group" appearance="standard">
                                    <mat-label>{{ 'uploadFileName' | translate }}</mat-label>
                                    <input id="uploadFilename" class="form-control inputTheme" formControlName="uploadFileName" 
                                        required readonly 
                                        matInput #input placeholder="{{ 'uploadFileName' | translate }}"
                                        >
                                    </mat-form-field>
                            </div>
                           
                        </div>

                    </mat-card-content>
                    <mat-card-actions>
                        <div class="container-fluid d-flex justify-content-between" >
                            <button *ngIf="uploadForm.valid && doUpload" mat-raised-button  #buttonSubmit type="submit" (click)="uploadFile()" >
                                <mat-icon>cloud_upload</mat-icon>
                                {{ 'uploadFiles' | translate }}
                            </button>
                            <button *ngIf="uploadForm.valid && doVerify" mat-raised-button  #buttonSubmit type="submit" (click)="verifyFile()" >
                                <mat-icon> insert_drive_file</mat-icon>
                                {{ 'verifyFiles' | translate }}
                            </button>
                        </div>
                    </mat-card-actions>
                </mat-card>
            </form>
        </div>
    </div>
</ng-template>